import React, { useEffect, useRef, ReactNode } from "react";
import { OutsideClick } from "@me8eon/components";


export const SimpleOutsideClick: OutsideClick = ({ onClickOutside, children }) => {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                onClickOutside?.();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onClickOutside]);

    return <div ref={ref}>{children}</div>;
};
